export default "__VITE_ASSET__IeS_ClSg__"